export type EnvironmentKeys =
  | 'ID4_ID'
  | 'ID4_ISSUER'
  | 'PIPELINE_ENV'
  | 'API_BASE_URL'
  | 'CATALOG_BASE_API_URL'
  | 'ORIGIN_URL';

export function getConfig(key: EnvironmentKeys) {
  return (typeof window === 'undefined' ? process.env[key] : globalThis?.window?.[`__${key}__`]) as string;
}
